import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import Location from '@r6digital/rapidstor-types/react/entities/Location';
import { GoogleMap, MarkerF, useJsApiLoader } from '@react-google-maps/api';

import { selectAllLocations } from '../features/rapidstor/rapidstorApiSlice';

import classes from './Map.module.scss';

import MapPin from '../assets/mapPin.png';

export const options = {
    apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
    center: {
        lat: -31.941530271728467,
        lng: 115.850385613311,
    },
    zoom: 24,
};

function Map() {
    const locations = useSelector(selectAllLocations);

    const [map, setMap] = useState<google.maps.Map>();

    const mapLoaded = (map: google.maps.Map) => {
        setMap(map);
    };

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: options.apiKey,
    });

    useEffect(() => {
        if (!map) {
            return;
        }
        const bounds = new google.maps.LatLngBounds();
        for (const location of locations) {
            bounds.extend({ lat: location.latitude, lng: location.longitude });
        }
        map.fitBounds(bounds);
    }, [map, locations]);

    return isLoaded ? (
        <GoogleMap
            center={options.center}
            zoom={options.zoom}
            mapContainerClassName={classes.map}
            onLoad={mapLoaded}
            options={{
                disableDefaultUI: true,
            }}
        >
            {locations.map((location: Location) => (
                <MarkerF
                    key={location.locationCode}
                    position={{ lat: location.latitude, lng: location.longitude }}
                    label={{
                        text: location.name.replace('U-Store-It ', ''),
                        color: 'white',
                        fontSize: '10px',
                    }}
                    icon={{
                        url: MapPin,
                        scaledSize: new google.maps.Size(68, 30.08),
                        labelOrigin: new google.maps.Point(34, 6.5),
                    }}
                />
            ))}
            <></>
        </GoogleMap>
    ) : (
        <>Loading map...</>
    );
}

export default Map;
